<app-calendar-create-event-middel (create)="setAndSubmit($event)" (formReset)="close()" [activities]="data.params?.activities" [showPreviousStep]="false"></app-calendar-create-event-middel>
